import { TREIN_LAYER_NAME, TREIN_WORKSPACE } from 'src/assets/constants/constants';

// The lower boundary belongs to the stronger signal class.
export const TRAIN_SIGNAL_CLASSES = [
    { label: 'train.signal.weak', color: '#D7191C', range: 'RSRP < -110 dBm' },
    { label: 'train.signal.sufficient', color: '#F28E2B', range: '-110 ≤ RSRP < -97.5 dBm' },
    { label: 'train.signal.good', color: '#F6D55C', range: '-97.5 ≤ RSRP < -85 dBm' },
    { label: 'train.signal.veryGood', color: '#1A9641', range: 'RSRP ≥ -85 dBm' },
] as const;

export function trainProviderFilter(provider: string): string {
    const providers = ['Proximus', 'Orange', 'Telenet'];
    const selected = providers.includes(provider) ? provider : 'Proximus';
    return `measurementtype='indoor' AND provider='${selected}'`;
}

export function trainDetails(properties: Record<string, unknown>) {
    const normalized = new Map(Object.entries(properties).map(([key, value]) => [key.toLowerCase(), value]));
    const value = (...keys: string[]): string => {
        const found = keys.map((key) => normalized.get(key.toLowerCase())).find((item) => item !== undefined && item !== null && item !== '');
        return found === undefined ? '—' : String(found);
    };

    const speed = value('download_mbps', 'Speed_downloadspeed');
    const numericSpeed = speed === '—' ? NaN : Number(speed.replace(',', '.'));
    return [
        { label: 'train.provider', value: value('provider') },
        { label: 'train.trackcode', value: value('trackcode', 'treinlijnen') },
        { label: 'train.trajectory', value: value('trajectory', 'traject') },
        { label: 'train.download', value: Number.isFinite(numericSpeed) && numericSpeed >= 0 ? `${numericSpeed} Mbit/s` : '—' },
    ];
}

// One compact inline SLD keeps the frontend and legend colours identical.
// Diameters double the existing GeoServer style's 5 / 7 / 9 / 11 px.
export function trainStyle(): string {
    const literal = (value: string | number) => `<ogc:Literal>${value}</ogc:Literal>`;
    const colors = TRAIN_SIGNAL_CLASSES.map((item, index) => (index ? literal(index - 0.5) : '') + literal(item.color)).join('');
    return `<StyledLayerDescriptor version="1.0.0" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc"><NamedLayer><Name>${TREIN_WORKSPACE}:${TREIN_LAYER_NAME}</Name><UserStyle><Name>treinmetingen_indoor</Name><IsDefault>1</IsDefault><FeatureTypeStyle><Rule><PointSymbolizer><Graphic><Mark><WellKnownName>circle</WellKnownName><Fill><CssParameter name="fill"><ogc:Function name="Categorize"><ogc:PropertyName>signal_quality</ogc:PropertyName>${colors}</ogc:Function></CssParameter></Fill><Stroke><CssParameter name="stroke">#FFFFFF</CssParameter><CssParameter name="stroke-width">0.6</CssParameter></Stroke></Mark><Size><ogc:Function name="Categorize"><ogc:Function name="env">${literal('wms_scale_denominator')}${literal(50000)}</ogc:Function>${literal(22)}${literal(5000)}${literal(18)}${literal(20000)}${literal(14)}${literal(50000)}${literal(10)}</ogc:Function></Size></Graphic></PointSymbolizer></Rule></FeatureTypeStyle></UserStyle></NamedLayer></StyledLayerDescriptor>`;
}
